import React, { useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { moveInRight } from "../../animations/MoveInRight";
import { IoCloseOutline } from "react-icons/io5";
import fontSize from "../../../theme/fonts/FontTheme";
import colors from "../../../theme/color/ColorTheme";
import CartItem from "./CartItem";
import CartBilling from "./CartBilling";
import CartItemEditCard from "./CartItemEditCard";
import PrimaryButton from "../../buttons/PrimaryButton";

const Wrapper = styled.div``;

const DimBackground = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000;
`;

const Container = styled.div`
  position: fixed;
  top: 40px;
  right: 0;
  height: calc(100vh - 40px);
  width: 380px;
  max-width: 100%;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 60px 40px -7px;
  animation: ${moveInRight} 0.35s ease forwards;
  padding: 25px;
  z-index: 2001;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow-y: auto;
`;

const Header = styled.div`
  border-bottom: 1px solid ${colors.line};
`;

const CloseIcon = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  color: black;
  font-size: 24px;
  cursor: pointer;
`;

const Title = styled.div`
  padding-bottom: 24px;
  color: ${colors.black};
  text-transform: uppercase;
  font-size: ${fontSize.s};
`;

const CartItems = styled.div`
  display: flex;
  flex-direction: column;
`;

function SidemenuCartEdit({ onClose }) {
  return ReactDOM.createPortal(
    <Wrapper>
      <DimBackground onClick={onClose} />
      <Container>
        <Header>
          <Title>Edit</Title>
          <CloseIcon onClick={onClose}>
            <IoCloseOutline />
          </CloseIcon>
        </Header>
        <CartItems>
          <CartItemEditCard />
        </CartItems>

        <PrimaryButton title="Update" onClick={onClose}/>
      </Container>
    </Wrapper>,
    document.body
  );
}

export default SidemenuCartEdit;
